/*
 *
 * OperationActionsModal
 *
 * @version 1.0.0
 * @author Davide Campus
 * @since 31-Oct-2024
 */

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { doPopup } from 'Store/actions/popup'
import OperationActionsModal from './OperationActionsModal'
import * as OperationManagementActions from 'Store/actions/operations'
import * as formikActions from 'Store/actions/formik'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(OperationManagementActions, dispatch),
  ...bindActionCreators(formikActions, dispatch),
  closePopup: () => dispatch(doPopup(''))
})

const mapStateToProps = (state) => ({
  data: state?.popup?.popupData || {},
  isLoading: state.loading?.local_operationAction || false,
  isOperation: /operationmanagement/i.test(window.location.pathname) || false
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(OperationActionsModal)
